<template>
    <main>
        <h1>Titre du jeu</h1>
        <p class="viewCount">Joué 0 fois</p>
        
        <section class="gameSection">
            <div class="game">
                <div class="player"></div>
                <div class="tags">
                    <span>Réflexion</span>
                    <span>Jeu de course</span>
                    <span>Action</span>
                    <span>Jeu clicker</span>
                </div>
            </div>
            <div class="other-games">
                <div class="jeu-container" v-for="i in 8" :key="i">
                    <div class="jeu">
                        <div class="img"></div>
                        <div class="contenu">
                            <p>Titre du jeu</p>
                            <span>Joué 0 fois</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
    export default {
        name: 'SkeletonJeu'
    }
</script>

<style scoped src="@/assets/game.css">
</style>
<style scoped src="@/assets/skeletonJeu.css">
</style>